var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"null-block flex"},[_c('i',{staticClass:"el-icon-tickets icons"}),_c('p',{staticClass:"txt"},[_vm._v(_vm._s(_vm.msgTxt))])])}
var staticRenderFns = []

export { render, staticRenderFns }